import React, { useState, useRef, useEffect, useCallback } from 'react';
// import { useTranslation } from "react-i18next";
import { Col, Row } from "react-bootstrap";
import { motion } from "framer-motion";
import Table from 'react-bootstrap/Table';
// import "./index.scss";

import SkeletonLoader from "../../../../../components/ui/SkeletonLoader";
import Pagination from "../../../../../components/ui/Pagination";
import NoDataFound from "../../../../../components/ui/NoDataFound";
import CustomTooltip from "../../../../../components/ui/Tooltip";

import ListFilter from "../../../../../components/PostLogin/ScanInfo/ExposureManagement/ConcerningExposure/ListFilter";

import { searchIcon } from "../../../../../utils/icons";
import { formatDate, formatNumber } from "../../../../../utils/util";

import { useScanInfoContext } from "../../../../ScanInfo/ScanInfoContext";

import apiEndpoints from "../../../../../apiEndpoints";

import { useSelector, useDispatch } from 'react-redux';
import { getThirdPartyRiskStats, resetThirdPartyRiskStats, getLeakedCredentialsList, resetLeakedCredentialsList } from "../../../../../store/actions/thirdPartyRiskAction";

const CredentialsLeak = () => {

    const leakedCredentialsStatsResponse = useSelector((state) => state.thirdPartyRisk?.thirdPartyRiskStats);
    const leakedCredentialsListResponse = useSelector((state) => state?.thirdPartyRisk?.leakedCredentialsList);

    const prevDomainIdRef = useRef(null);
    const prevScanIdRef = useRef(null);

    const dispatch = useDispatch();

    const { domainId, scanId, organizationId } = useScanInfoContext();

    const [searchValue, setSearchValue] = useState("");
    const [searchQuery, setSearchQuery] = useState("");
    const [isSearchFocused, setIsSearchFocused] = useState(false);

    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageSize, setCurrentPageSize] = useState(10);
    const [isLoading, setIsLoading] = useState(false);
    const [leakedCredentialsList, setLeakedCredentialsList] = useState(null);
    const [scanNotFound, setScanNotFound] = useState(false);

    const [statsLoading, setStatsLoading] = useState(false);
    const [leakedCredentialsStats, setLeakedCredentialsStats] = useState(null);

    //selected list filter
    const [listFilterValue, setListFilterValue] = useState({});

    const listFilterApply = (data) => {
        setListFilterValue(data)
    }

    const isAnyFilterActive = Object.values(listFilterValue).some(value => Boolean(value));

    const resetFilterValue = () => {
        setCurrentPage(1);
        setListFilterValue({})
    }

    const handleSearchKeyDown = (event) => {
        if (event.key === "Enter" && isSearchFocused) {
            onSearch()
        }
    }

    const onSearch = () => {
        setCurrentPage(1)
        setSearchQuery(searchValue)
    }

    const setCurrentPageandRecordSize = (currentPage, pageSize) => {
        setCurrentPage(currentPage);
        if(pageSize !== currentPageSize) {
            setCurrentPageSize(pageSize);
            setCurrentPage(1);
        }
    }
            
    const fetchLeakedCredentialsStats = useCallback(()=>{
        setStatsLoading(true)
        const baseUrl = `${apiEndpoints.scanInfo.thirdPartyRisk.compromiseIndicator.leakedCredentials.leakedCredentialsStats()}`
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const url = `${baseUrl}${params}`
        dispatch(getThirdPartyRiskStats(url))
    },[dispatch, domainId, scanId, organizationId])

    const fetchLeakedCredentialsList = useCallback(()=>{
        setIsLoading(true)
        const baseUrl = `&page=${currentPage}&page_size=${currentPageSize}`;
        const params = organizationId.toLowerCase() !== "all" && domainId.toLowerCase() === "all" ? `&organization_id=${organizationId}`: `&domain=${domainId}&scan_id=${scanId}`
        const queryParams = searchQuery ? `&query=${searchQuery}` : "";
        const newFindings = listFilterValue?.newFindings?.value && listFilterValue?.newFindings?.value !== "all" ? `&new_record=${listFilterValue?.newFindings?.value === "yes" ? true : false}` : "";
        const emailStatus = listFilterValue?.emailStatus?.value && listFilterValue?.emailStatus?.value !== "all" ? `&email_status=${listFilterValue?.emailStatus?.value}` : "";
        const url = `${baseUrl}${params}${queryParams}${newFindings}${emailStatus}`
        dispatch(getLeakedCredentialsList(url))
    },[currentPage, currentPageSize, domainId, organizationId, scanId, searchQuery, listFilterValue, dispatch])

    useEffect(()=>{
        fetchLeakedCredentialsList()
    },[currentPage, fetchLeakedCredentialsList])

    useEffect(()=>{
        if(domainId !== prevDomainIdRef.current || scanId !== prevScanIdRef.current) {
            fetchLeakedCredentialsStats()
            setCurrentPage(1);
            prevDomainIdRef.current = domainId;
            prevScanIdRef.current = scanId;
        }
    },[domainId, scanId, fetchLeakedCredentialsStats])

    useEffect(()=>{
        if(leakedCredentialsStatsResponse !== null) {
            setLeakedCredentialsStats(leakedCredentialsStatsResponse)
            dispatch(resetThirdPartyRiskStats())
            setStatsLoading(false)
        }
    },[leakedCredentialsStatsResponse, dispatch])

    useEffect(()=>{
        if(leakedCredentialsListResponse !== null) {
            setLeakedCredentialsList(leakedCredentialsListResponse)
            if(leakedCredentialsListResponse?.status === "failed") {
                setScanNotFound(true)
            } else {
                setScanNotFound(false)
            }
            dispatch(resetLeakedCredentialsList())
            setIsLoading(false)
        }
    },[leakedCredentialsListResponse, dispatch])

    return (
        <>
            <div className="scan-info-main-content sensitive-exposure-main-content">
                <div className="bg-white-with-shadow p-4">
                    <Row>
                        <Col lg={4}>
                            <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"criticalVulnerabilities"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Leaked Credentials</p>
                                        </div>
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(leakedCredentialsStats?.stats?.record_type?.total)}</p>
                                                <div className="score-count mx-3">
                                                    <span className="new-record d-inline-block mx-1"></span>
                                                    <span className="existing-record d-inline-block"></span>
                                                    <p>Total Leaked Credentials</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-5 mt-3">
                                                <p className="new-record"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.stats?.record_type?.new_record)}</span> New</p>
                                                <p className="existing-record"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.stats?.record_type?.existing_record)}</span> Existing</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                        <Col lg={4}>
                            <div className="discover-doamin-container associated-doamin-page rounded p-3 h-100">
                                {
                                    statsLoading ?
                                    <SkeletonLoader type={"line"} count={2} currentPage={"sslVulnerabilities"} />
                                    :
                                    <motion.div
                                        initial={{ opacity: 0, y: 20 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{ duration: 0.4 }}
                                    >
                                        
                                        <div className="header-content d-flex justify-content-between">
                                            <p className="heading">Email Status</p>
                                        </div>
                                        <div className="total-score-container rounded">
                                            <div className="users-totol-count d-flex">
                                                <p className="total-score-count">{formatNumber(leakedCredentialsStats?.stats?.email_status_type?.total)}</p>
                                                <div className="score-count mx-3">
                                                <span className="existing-record closed d-inline-block mx-1"></span>
                                                    <span className="new-record open d-inline-block"></span>
                                                    <p>Total Leaked Email ID's</p>
                                                </div>
                                            </div>
                                            <div className="new-exist-count d-flex gap-5 mt-3">
                                                <p className="existing-record closed"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.stats?.email_status_type?.active)}</span> Active</p>
                                                <p className="new-record open"><span className="d-inline-block">{formatNumber(leakedCredentialsStats?.stats?.email_status_type?.inactive)}</span> Inactive</p>
                                            </div>
                                        </div>
                                    </motion.div>
                                }
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="domain-similarities-container git-leaks-main-content bg-white-with-shadow p-3 mt-3">
                    <div className="search-header-container d-flex align-items-center gap-3">
                        <div className="d-flex gap-3">
                            <div className="search-container position-relative" onKeyDown={handleSearchKeyDown}>
                                <span className="position-absolute">{searchIcon()}</span>
                                <input type="text" 
                                    placeholder="Search"
                                    onChange={(e)=>{
                                        setSearchValue(e.target.value)
                                    }}
                                    onFocus={() => setIsSearchFocused(true)}
                                    onBlur={() => setIsSearchFocused(false)}
                                />
                            </div>
                            <button className="search-btn" onClick={onSearch}>Search</button>
                        </div>
                        <ListFilter listFilterApply={listFilterApply} listFilterValue={listFilterValue} currentPage={"leakedCredentials"} />
                        {isAnyFilterActive && (<span className="reset-filter-link" onClick={resetFilterValue}>Reset Filter</span>)}
                    </div>
                    <div className="table-container js-secrets-table mt-4">
                        {
                            isLoading ?
                            <SkeletonLoader type={"line"} count={5} currentPage={"cvesList"} />
                            :
                            <Table>
                                <thead>
                                    <tr>
                                        <th>Email Address</th>
                                        <th>Leak Name</th>
                                        <th>Leak Description</th>
                                        <th>Leak Data Class</th>
                                        <th>Leaked Date</th>
                                        <th>Email Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        leakedCredentialsList?.results?.length > 0 &&
                                        leakedCredentialsList?.results.map((data, index)=>{
                                            return (
                                                <motion.tr
                                                    key={index}
                                                    initial={{ opacity: 0, y: 20 }}
                                                    animate={{ opacity: 1, y: 0 }}
                                                    transition={{ duration: 0.4, delay: index * 0.1 }}
                                                >
                                                    <td>
                                                        <p className="dns-record-subdomain">{data?.breached_email} {data?.new_record &&<span className="d-inline-block new-data mr-2">New</span>}</p>
                                                        <span className="dns-record-domain">{data?.leak_domain}</span>
                                                    </td>
                                                    <td>{data?.leak_name}</td>
                                                    <td className="cves-table-description">
                                                        {data?.leak_description !== null && data?.leak_description !== "" ? <span className="author-name">{
                                                            data?.leak_description.length > 120 ?
                                                            <CustomTooltip content={data?.leak_description} position={"top"}>
                                                                {data?.leak_description.slice(0, 120) + "..." }
                                                            </CustomTooltip>
                                                            : data?.leak_description
                                                        }</span> : "-"}
                                                    </td>
                                                    <td>{data?.leak_data_classes.join(", ")}</td>
                                                    <td>{formatDate(data?.leak_date)}</td>
                                                    <td className="status-container">
                                                        {data.email_status === "active" ? <p className="status-close">Active</p> : <p className="status-open text-capitalize">{data.email_status}</p>}
                                                    </td>
                                                </motion.tr>
                                            )
                                        })
                                    }
                                </tbody>
                            </Table>
                        }
                        
                        { !isLoading && leakedCredentialsList && !scanNotFound && leakedCredentialsList?.results?.length > 0 &&
                            <Pagination
                                className="pagination-bar"
                                currentPage={currentPage}
                                pageSize={currentPageSize}
                                totalCount={leakedCredentialsList?.meta?.total_results}
                                onPageChange={setCurrentPageandRecordSize}
                            />
                        }
                        {
                            !isLoading && !scanNotFound && leakedCredentialsList !== "" && leakedCredentialsList?.results?.length === 0 && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={"No Record Found"}/>
                            </motion.div>
                        }
                        {
                            !isLoading && scanNotFound && 
                            <motion.div
                                initial={{ opacity: 0, y: 20 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{ duration: 0.4 }}
                            >
                                <NoDataFound noDataText={leakedCredentialsList?.description}/>
                            </motion.div>
                        }
                    </div>
                </div>
            </div>
        </>
    )
}


export default CredentialsLeak;